import { Platform } from "react-native";

const isAndroid = () => Platform.OS === "android";
const isIOS = () => Platform.OS === "ios";
const isWeb = () => Platform.OS === "web";
const isSamsung = () =>
  Platform.OS === "android" && Platform.constants.Brand === "samsung";

const isSamsungAPI35Plus = () =>
  isAndroid() && isSamsung() && Number(Platform.Version) >= 35;

export { isAndroid, isIOS, isSamsungAPI35Plus, isWeb };
